<script>
import AppButtonsCadastroSicarf from '@/components(new)/UI/Buttons/ButtonsCadastroSicarf/ButtonsCadastroSicarf.vue'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import { cloneDeep, merge, pickBy, identity } from 'lodash'
import { mapActions, mapGetters } from 'vuex'
import { validaTipoCadastro } from '@/utils/utils'

const NOT_FORM_TABS = ['formulario-georreferenciamento']

export default {
  mixins: [
    AppNotificacao
  ],

  components: {
    AppButtonsCadastroSicarf
  },

  props: {
    titleCadastro: {
      type: String,
      required: true
    },
    routeName: {
      type: String,
      required: true
    },
    cadastroEmpty: {
      type: Object
    },
    tabs: {
      type: Array,
      required: true
    },
    tipoCadastro: {
      required: true,
      validator: value => validaTipoCadastro(value)
    }
  },

  data () {
    return {
      isLoading: false,
      cadastro: {},
      idCadastro: 0,
      isRetificacao: false,
      pathDocumentosRemover: [],
      isCadastroNovo: true,
      tabVisual: this.$route.name,
      ajusteAbasDesdeNavegacao: false
    }
  },

  async created () {
    this.isRetificacao = this.$route.params?.isRetificacao || false
    this.tabVisual = this.$route.name
    if (this.$route.params.idCadastro && this.$route.params.idCadastro !== 'new') {
      this.isCadastroNovo = false
      try {
        const response = await this.findByIdCadastro(this.$route.params.idCadastro)
        this.mergeCadastro(response)
      } catch (e) {
        this.$router.push({
          name: 'listagem/' + this.routeName
        })
      }
    } else {
      this.isCadastroNovo = true
      this.cadastro = cloneDeep(this.cadastroEmpty)
    }
    if (this.isRetificacao) {
      this.titleCadastro = 'Retificar cancelamento de cláusula resolutiva'
    }
    this.$nextTick(() => {
      this.$emit('has-processo-changed', this.hasProcesso)
    })
  },

  computed: {
    ...mapGetters({
      usuario: 'auth/usuarioLogado'
    }),

    indexTabAtual () {
      return this.tabs.findIndex((tab) => tab.name === this.$route.name)
    },

    menu () {
      return this.$route.name
    },

    menuControlado () {
      return this.tabVisual
    },

    isPrimeiroPasso () {
      return this.indexTabAtual === 0
    },

    isIntroPasso () {
      return this.$route.meta && this.$route.meta.isIntro
    },

    isResumo () {
      return this.indexTabAtual === this.tabs.length - 1
    },

    cadastroJson () {
      return this.cadastro.json
    },

    tabsFiltered () {
      return this.tabs.filter(item => !item.isResumo && !item.isIntro)
    },

    protocolCode () {
      return this.cadastro.protocolo
    },

    hasProcesso () {
      return !!this.cadastro.numeroProcesso
    }
  },

  async beforeRouteUpdate (to, from, next) {
    try {
      if (this.$refs.observer && this.$refs.observer.refs) {
        delete this.$refs.observer.refs['$ignoreValues$']
      }
    } catch (error) {
      console.log('error', error)
    }
    next()
  },

  watch: {
    '$route.name' (name) {
      if (name) {
        this.ajusteAbasDesdeNavegacao = true
        this.tabVisual = name
        this.$nextTick(() => {
          this.ajusteAbasDesdeNavegacao = false
        })
      }
    },

    hasProcesso (newValue) {
      this.$emit('has-processo-changed', newValue)
    }
  },

  methods: {
    ...mapActions({
      findByIdCadastro: 'cadastro/findByIdCadastro',
      salvar: 'cadastro/salvarCadastro',
      encerrarRetificacaoCancelamento: 'processo/encerrarRetificacaoCancelamento',
      finalizar: 'cadastro/finalizarCadastro',
      removeByPath: 'cadastro/removeByPath',
      removeCadastroById: 'cadastro/removeCadastroById'
    }),

    isMaranhao () {
      return process.env.ESTADO === 'ma'
    },

    mergeCadastro (cadastro) {
      if (!cadastro || !cadastro.json) {
        return
      }
      cadastro.json = typeof cadastro.json === 'string' ? JSON.parse(cadastro.json) : cadastro.json
      if (this.isRetificacao) {
        this.cadastro = merge(
          {},
          cloneDeep(this.cadastroEmpty),
          pickBy(cadastro, identity)
        )
      } else {
        this.cadastro = merge(
          {},
          cloneDeep(this.cadastroEmpty),
          pickBy(cadastro, identity)
        )
      }
      this.idCadastro = cadastro.id
    },

    formataRots () {
      return this.$route.path.includes('central') ? '' : this.$route.path.split('/')[1] + '/'
    },

    sincronizarAbaComRota () {
      this.ajusteAbasDesdeNavegacao = true
      this.tabVisual = this.$route.name
      this.$nextTick(() => {
        this.ajusteAbasDesdeNavegacao = false
      })
    },

    normalizarResultadoValidacao (result) {
      if (result == null) {
        return false
      }
      if (typeof result === 'object' && 'valid' in result) {
        return !!result.valid
      }
      return !!result
    },

    async redefinirValidacaoObserver () {
      await this.$nextTick()
      // Segundo tick: o keep-alive/rotas precisam trocar o filho ativo antes de limpar o observer
      await this.$nextTick()
      const obs = this.$refs.observer
      if (obs && typeof obs.reset === 'function') {
        obs.reset()
      }
    },

    validarCampos () {
      try {
        if (this.$refs.observer && this.$refs.observer.refs) {
          delete this.$refs.observer.refs['$ignoreValues$']
        }
      } catch (error) {
        console.log('error', error)
      }
      if (NOT_FORM_TABS.includes(this.$route.name)) {
        if (this.$refs.childComp && this.$refs.childComp.validate) {
          try {
            const resultado = this.$refs.childComp.validate()
            return resultado
          } catch (error) {
            return false
          }
        } else {
          return false
        }
      }

      return this.$nextTick().then(() => {
        return new Promise(resolve => setTimeout(resolve, 300))
      }).then(() => {
        return this.$refs.observer.validate().then(result => {
          return result
        }).catch(error => {
          console.error('error:', error)
          return false
        })
      }).catch(error => {
        console.error('error:', error)
        return false
      })
    },

    async validarCamposTab (label) {
      delete this.$refs.observer.refs['$ignoreValues$']

      await this.$nextTick()
      await new Promise(resolve => setTimeout(resolve, 300))

      if (label) {
        return this.getErrosTab(label)
      }
      return []
    },

    async proximo (indexDestino = this.indexTabAtual + 1, validate = true) {
      if (indexDestino < this.indexTabAtual && this.tabs[indexDestino]) {
        await this.$router.push({
          name: this.tabs[indexDestino].name,
          params: { idCadastro: this.cadastro.id }
        })
        this.tabVisual = this.tabs[indexDestino].name
        await this.redefinirValidacaoObserver()
        return
      }

      let isValid = true
      if (validate) {
        if (NOT_FORM_TABS.includes(this.$route.name)) {
          isValid = this.normalizarResultadoValidacao(
            await Promise.resolve(this.validarCampos())
          )
        } else {
          await this.validarCampos()
          const errosAbaAtual = await this.validarCamposTab(
            this.tabs[this.indexTabAtual]?.label
          )
          isValid = (errosAbaAtual == null || errosAbaAtual.length === 0)
        }
      }

      if (!isValid) {
        this.sincronizarAbaComRota()
        this.showNotificacao(
          this.$messages.TIPO_WARNING,
          this.$messages.TITULO_WARNING,
          this.$messages.VALIDATION_FAIL
        )
        return
      }

      await this.salvarCadastro(false, false)

      await this.$router.push({
        name: this.tabs[indexDestino].name,
        params: { idCadastro: this.cadastro.id }
      })
      this.tabVisual = this.tabs[indexDestino].name
    },

    getRotaRetornoFinalizaRetificacao () {
      return this.$route.path.includes('central') ? 'central/processos' : 'receptor/listagem'
    },

    async finalizarRetificacao () {
      try {
        this.isLoading = true
        if (this?.cadastro?.protocolo) {
          await this.encerrarRetificacaoCancelamento(this.cadastro.protocolo)
        }
        this.showNotificacao(
          this.$messages.TIPO_SUCCESS,
          this.$messages.TITULO_SUCCESS,
          this.hasProcesso ? this.$messages.CADASTRO_EDITADO_SUCESSO : this.$messages.DADOS_SALVOS_SUCESSO
        )
      } catch (error) {
        this.showNotificacao(
          this.$messages.TIPO_ERROR,
          this.$messages.TITULO_ERROR,
          error.message
        )
        throw error
      } finally {
        this.isLoading = false
      }

      this.$router.push({
        name: this.getRotaRetornoFinalizaRetificacao()
      })
    },

    async salvarCadastro (validarForm = true, exibirToast = true) {
      if (this.pathDocumentosRemover.length > 0) {
        await this.removeByPath(this.pathDocumentosRemover)
        this.pathDocumentosRemover = []
      }

      if (this.cadastro.json && typeof this.cadastro.json === 'object') {
        const jsonObj = this.cadastro.json
        if (jsonObj.imovel?.endereco?.municipio && !jsonObj.imovel.endereco.municipio.id) {
          jsonObj.imovel.endereco.municipio = null
        }
        if (jsonObj.proprietario?.pessoa?.enderecoCorrespondencia?.municipio && !jsonObj.proprietario.pessoa.enderecoCorrespondencia.municipio.id) {
          jsonObj.proprietario.pessoa.enderecoCorrespondencia.municipio = null
        }
      }

      if (this.$route.name === 'formulario-georreferenciamento') {
        await this.$refs.childComp.submit()
        if (exibirToast) {
          this.showNotificacao(
            this.$messages.TIPO_SUCCESS,
            this.$messages.TITULO_SUCCESS,
            this.hasProcesso ? this.$messages.CADASTRO_EDITADO_SUCESSO : this.$messages.DADOS_SALVOS_SUCESSO
          )
          return
        }
      }
      if (validarForm) await this.validarCampos()

      try {
        this.isLoading = true
        const cadastroParaSalvar = { ...this.cadastro, json: JSON.stringify(this.cadastro.json) }
        let response
        // se for uma tab que não é um form, exponha o método de submit
        if (NOT_FORM_TABS.includes(this.$route.name)) {
          response = await this.$refs.childComp.submit()
        } else {
          response = await this.salvar(cadastroParaSalvar)
        }
        if (response && response.json) {
          this.mergeCadastro(response)
        }
        if (exibirToast) {
          this.showNotificacao(
            this.$messages.TIPO_SUCCESS,
            this.$messages.TITULO_SUCCESS,
            this.hasProcesso ? this.$messages.CADASTRO_EDITADO_SUCESSO : this.$messages.DADOS_SALVOS_SUCESSO
          )
        }
        this.isLoading = false
        if (this.$route.params.idCadastro === 'new') {
          this.$router.push({
            name: this.tabs[0].name,
            params: {
              idCadastro: this.cadastro.id
            }
          })
        }
      } catch (error) {
        this.isLoading = false
        this.showNotificacao(
          this.$messages.TIPO_ERROR,
          this.$messages.TITULO_ERROR,
          error.message
        )
        throw error
      }
    },

    async voltar () {
      if (this.isIntroPasso) {
        this.$router.push({
          name: 'listagem/' + this.routeName
        })
        return
      }

      await this.proximo(this.indexTabAtual - 1, false)
    },

    async cancelar () {
      const jaVirouProcesso = this.hasProcesso && this.cadastro.numeroProcesso
      const isEdicaoProcessoFinalizado = !this.isCadastroNovo && jaVirouProcesso

      let mensagem = 'Você tem certeza que deseja cancelar? Todos os dados não salvos serão perdidos.'
      if (isEdicaoProcessoFinalizado) {
        mensagem = 'Você tem certeza que deseja cancelar? Todos os dados editados serão perdidos.'
      }

      this.confirmBox(mensagem, this.$messages.TITULO_WARNING,
        async () => {
          try {
            if (isEdicaoProcessoFinalizado) {
              await this.removeCadastroById(this.idCadastro)
            }

            this.$router.push({
              name: 'listagem/' + this.routeName
            })
          } catch (error) {
            this.showNotificacao(
              this.$messages.TIPO_ERROR,
              this.$messages.TITULO_ERROR,
              'Erro ao cancelar edição: ' + error.message
            )
          }
        },
        () => {
        }, 'Sim', 'Não')
    },

    async finalizarCadastro () {
      await this.salvarCadastro()
      if (this.isRetificacao) {
        this.finalizarRetificacao()
        await this.finalizar(this.cadastro.id)
        return
      }

      try {
        const response = await this.validarCampos()

        if (response) {
          try {
            await this.finalizar(this.cadastro.id)

            this.showNotificacao(
              this.$messages.TIPO_SUCCESS,
              this.$messages.TITULO_SUCCESS,
              this.$messages.CADASTRO_CRIADO_SUCESSO
            )

            this.$router.push({
              name: 'listagem/' + this.routeName
            })

            return
          } catch (error) {
            if (error?.errors?.[0]?.parameter === 'CADASTRO_DESATUALIZADO') {
              this.$router.push({
                name: 'listagem/finalizados'
              })
            }
            return
          }
        }

        this.showNotificacao(
          this.$messages.TIPO_WARNING,
          this.$messages.TITULO_WARNING,
          this.$messages.ERRO_VALIDACAO_FINALIZAR_CADASTRO
        )
      } catch (error) {
        let message = error.message

        this.showNotificacao(
          this.$messages.TIPO_ERROR,
          this.$messages.TITULO_ERROR,
          message
        )
      }
    },

    async mudarTab (tabClick) {
      if (this.ajusteAbasDesdeNavegacao) {
        return
      }
      const tabName = typeof tabClick === 'string' ? tabClick : tabClick.name
      if (tabName === this.$route.name) {
        this.tabVisual = this.$route.name
        return
      }
      const indexTab = this.tabs.findIndex(tab => tab.name === tabName)
      if (indexTab === this.indexTabAtual) {
        this.tabVisual = this.$route.name
        return
      }

      await this.proximo(indexTab, indexTab > this.indexTabAtual)
    },

    tabPossuiErro (label) {
      let temErro = false
      if (this.$refs.observer) {
        for (const key in this.$refs.observer.errors) {
          if (key.substring(0, key.indexOf('/')) === label &&
            this.$refs.observer.errors[key].length > 0) {
            temErro = true
          }
        }
      }
      return temErro
    },

    getErrosTab (label) {
      let erros = []
      if (this.$refs.observer) {
        for (const key in this.$refs.observer.errors) {
          if (key.substring(0, key.indexOf('/')) === label &&
            this.$refs.observer.errors[key].length > 0) {
            const campo = key.substring(key.indexOf('/') + 1, key.length)
            erros.push(`${campo}: ${this.$refs.observer.errors[key][0]}`)
          }
        }
      }
      return erros
    },

    async navigate (indexTab) {
      if (indexTab === this.tabs.length) {
        const validate = await this.validarCampos()
        if (!validate) {
          this.showNotificacao(
            this.$messages.TIPO_ERROR,
            this.$messages.TITULO_ERROR,
            'Verifique os campos destacados antes de prosseguir'
          )
          return
        }
      }

      try {
        await this.salvarCadastro()

        this.tabAtivaControlada = this.tabs[indexTab].name

        this.$router.push({
          name: this.tabs[indexTab].name,
          params: {
            idCadastro: this.cadastro.id
          }
        })
      } catch (error) {
        this.tabAtivaControlada = this.$route.name
        throw error
      }
    },

    getLastEtapaByTipo (tipo) {
      const etapasEnds = new Map()

      etapasEnds.set('INFORMACOES', 'IMOVEL')
      etapasEnds.set('PERMUTA', 'GEORREFERENCIAMENTO')
      etapasEnds.set('AFORAMENTO', 'GEORREFERENCIAMENTO')
      etapasEnds.set('TRANSFERENCIA_DIREITOS', 'GEORREFERENCIAMENTO')
      etapasEnds.set('CANCELAMENTO_CLAUSULA_RESOLUTIVA', 'IMOVEL')
    },
    onPraticaRemovida (codigoPratica) {
      this.$nextTick(() => {
        let childComp = this.$refs.childComp
        if (!childComp) {
          childComp = this.$children.find(child =>
            child.$options.name === 'Georreferenciamento' ||
            child.$options._componentTag === 'georreferenciamento'
          )
        }
        if (childComp?.onPraticaRemovida) {
          childComp.onPraticaRemovida(codigoPratica)
        }
      })
    }
  }

}

</script>

<template lang="pug">
  div.container-cadastro
    .card-header.marginTitle
      h1 {{ titleCadastro }}
    .content
      el-tabs(v-model="tabVisual" :key="tabVisual" @tab-click="mudarTab")
        template(v-if="tab.label != 'Resumo'" v-for="tab in tabs")
          el-tab-pane(:name="tab.name" :key="tab.name")
            span.tab(slot="label")
              | {{tab.label}} &nbsp
              el-tooltip(effect='light', placement='bottom', v-if="tabPossuiErro(tab.label)")
                span(slot="content")
                  p(v-if="getErrosTab(tab.label).length > 0")
                    pre
                      | Preencha todos os campos obrigatórios!
                i.el-icon-warning.tooltip-icon

      div.container-tab
        validation-observer(ref='observer' tag='form')
          keep-alive
            router-view(
              ref="childComp"
              v-if="!isLoading && cadastroJson"
              :cadastro="cadastroJson"
              :protocolo="protocolCode"
              :idCadastro="idCadastro"
              :observer="$refs.observer"
              :pathDocumentosRemover="pathDocumentosRemover"
              :tipoCadastro="tipoCadastro"
              :hasProcesso="hasProcesso"
              @add-pratica="() => salvarCadastro(false, false)"
              @pratica-removida="onPraticaRemovida"
            )
    app-buttons-cadastro-sicarf(
      :isPrimeiroPasso="isPrimeiroPasso",
      :isUltimoPasso="isResumo",
      :isIntroPasso="isIntroPasso"
      :showButtonProximo="!isResumo"
      :showButtonSalvar="!isIntroPasso && !isResumo",
      @proximo="proximo",
      @salvar="salvarCadastro",
      @voltar="voltar",
      @cancelar="cancelar",
      @finalizar="finalizarCadastro"
    )
</template>

<style lang="scss" scoped>
@import './styles.scss'
</style>



// WEBPACK FOOTER //
// src/components(new)/UI/Forms/CadastroSicarf/CadastroSicarf.vue